// components/COEResultsCard.tsx
import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  Paper,
  ButtonBase,
  Grid,
  useTheme,
  alpha
} from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';
import DirectionsCarFilledRoundedIcon from '@mui/icons-material/DirectionsCarFilledRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import ElectricCarRoundedIcon from '@mui/icons-material/ElectricCarRounded';
import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded';
import TrendingDownRoundedIcon from '@mui/icons-material/TrendingDownRounded';
import HorizontalRuleRoundedIcon from '@mui/icons-material/HorizontalRuleRounded';

// --- HARDCODED DATA BASED ON PROVIDED IMAGES & UPDATES ---
const hardcodedCOEData = [
  // 2026-04
  { month: '2026-04', biddingNo: '1', vehicleClass: 'Category A', premium: '118000', quota: '1265', bidsReceived: '2537' },
  { month: '2026-04', biddingNo: '1', vehicleClass: 'Category B', premium: '121000', quota: '811', bidsReceived: '1406' },
  { month: '2026-04', biddingNo: '1', vehicleClass: 'Category C', premium: '80001', quota: '295', bidsReceived: '539' },
  { month: '2026-04', biddingNo: '1', vehicleClass: 'Category D', premium: '10000', quota: '534', bidsReceived: '657' },
  { month: '2026-04', biddingNo: '1', vehicleClass: 'Category E', premium: '121001', quota: '245', bidsReceived: '475' },

  // 2026-03
  { month: '2026-03', biddingNo: '2', vehicleClass: 'Category A', premium: '111890', quota: '1264', bidsReceived: '1895' },
  { month: '2026-03', biddingNo: '2', vehicleClass: 'Category B', premium: '115568', quota: '812', bidsReceived: '1185' },
  { month: '2026-03', biddingNo: '2', vehicleClass: 'Category C', premium: '78000', quota: '290', bidsReceived: '438' },
  { month: '2026-03', biddingNo: '2', vehicleClass: 'Category D', premium: '9589', quota: '546', bidsReceived: '726' },
  { month: '2026-03', biddingNo: '2', vehicleClass: 'Category E', premium: '118119', quota: '246', bidsReceived: '422' },
  { month: '2026-03', biddingNo: '1', vehicleClass: 'Category A', premium: '108220', quota: '1268', bidsReceived: '1762' },
  { month: '2026-03', biddingNo: '1', vehicleClass: 'Category B', premium: '114002', quota: '815', bidsReceived: '1261' },
  { month: '2026-03', biddingNo: '1', vehicleClass: 'Category C', premium: '76000', quota: '290', bidsReceived: '488' },
  { month: '2026-03', biddingNo: '1', vehicleClass: 'Category D', premium: '8602', quota: '545', bidsReceived: '643' },
  { month: '2026-03', biddingNo: '1', vehicleClass: 'Category E', premium: '114890', quota: '245', bidsReceived: '514' },

  // 2026-02
  { month: '2026-02', biddingNo: '2', vehicleClass: 'Category A', premium: '106501', quota: '1289', bidsReceived: '1975' },
  { month: '2026-02', biddingNo: '2', vehicleClass: 'Category B', premium: '105001', quota: '813', bidsReceived: '1353' },
  { month: '2026-02', biddingNo: '2', vehicleClass: 'Category C', premium: '74999', quota: '294', bidsReceived: '502' },
  { month: '2026-02', biddingNo: '2', vehicleClass: 'Category D', premium: '7989', quota: '548', bidsReceived: '665' },
  { month: '2026-02', biddingNo: '2', vehicleClass: 'Category E', premium: '112890', quota: '239', bidsReceived: '571' },
  { month: '2026-02', biddingNo: '1', vehicleClass: 'Category A', premium: '106320', quota: '1265', bidsReceived: '1982' },
  { month: '2026-02', biddingNo: '1', vehicleClass: 'Category B', premium: '110890', quota: '813', bidsReceived: '966' },
  { month: '2026-02', biddingNo: '1', vehicleClass: 'Category C', premium: '74801', quota: '292', bidsReceived: '420' },
  { month: '2026-02', biddingNo: '1', vehicleClass: 'Category D', premium: '8289', quota: '550', bidsReceived: '645' },
  { month: '2026-02', biddingNo: '1', vehicleClass: 'Category E', premium: '116000', quota: '271', bidsReceived: '462' },

  // 2026-01
  { month: '2026-01', biddingNo: '2', vehicleClass: 'Category A', premium: '109501', quota: '1301', bidsReceived: '2303' },
  { month: '2026-01', biddingNo: '2', vehicleClass: 'Category B', premium: '121634', quota: '803', bidsReceived: '1207' },
  { month: '2026-01', biddingNo: '2', vehicleClass: 'Category C', premium: '75202', quota: '283', bidsReceived: '434' },
  { month: '2026-01', biddingNo: '2', vehicleClass: 'Category D', premium: '8860', quota: '538', bidsReceived: '609' },
  { month: '2026-01', biddingNo: '2', vehicleClass: 'Category E', premium: '120891', quota: '299', bidsReceived: '426' },
  { month: '2026-01', biddingNo: '1', vehicleClass: 'Category A', premium: '102009', quota: '1285', bidsReceived: '1658' },
  { month: '2026-01', biddingNo: '1', vehicleClass: 'Category B', premium: '119100', quota: '824', bidsReceived: '1128' },
  { month: '2026-01', biddingNo: '1', vehicleClass: 'Category C', premium: '75503', quota: '287', bidsReceived: '394' },
  { month: '2026-01', biddingNo: '1', vehicleClass: 'Category D', premium: '8689', quota: '544', bidsReceived: '639' },
  { month: '2026-01', biddingNo: '1', vehicleClass: 'Category E', premium: '122000', quota: '278', bidsReceived: '528' },
];

const COECategories = ['A', 'B', 'C', 'E'];

// --- ANIMATIONS ---
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

const MotionPaper = styled(Paper)(({ theme }) => ({
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  overflow: 'hidden',
  position: 'relative',
  '&:hover': {
    boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
  }
}));

// --- STYLING HELPERS ---
const getCategoryDetails = (category: string) => {
  switch (category) {
    case 'A': return { name: 'CAT A', Icon: DirectionsCarFilledRoundedIcon, bgColor: '#FFF0E3', iconBoxColor: '#F97316' };
    case 'B': return { name: 'CAT B', Icon: DirectionsCarFilledRoundedIcon, bgColor: '#F3E8FF', iconBoxColor: '#7C3AED' };
    case 'C': return { name: 'CAT C', Icon: LocalShippingRoundedIcon, bgColor: '#FFFBEB', iconBoxColor: '#F59E0B' };
    case 'E': return { name: 'CAT E', Icon: ElectricCarRoundedIcon, bgColor: '#EFF6FF', iconBoxColor: '#2563EB' };
    default: return { name: `CAT ${category}`, Icon: DirectionsCarFilledRoundedIcon, bgColor: '#F3F4F6', iconBoxColor: '#6B7280' };
  }
};

// --- SAFE NUMBER PARSER TO PREVENT NaN ---
const parseNumberSafe = (val: any): number | null => {
  if (val === null || val === undefined || val === '') return null;
  const cleanVal = typeof val === 'string' ? val.replace(/,/g, '') : val;
  const num = Number(cleanVal);
  return isNaN(num) ? null : num;
};

// --- SUB-COMPONENT: TILE ---
const CategoryGridItem = ({
  category,
  premium,
  quota,
  bids,
  diff
}: {
    category: string, 
    premium: string, 
    quota: string, 
    bids: string, 
    diff: number | null 
}) => {
  const details = getCategoryDetails(category);
  const IconComponent = details.Icon;

  const isUp = diff !== null && diff > 0;
  const isDown = diff !== null && diff < 0;
  const isFlat = diff === 0 || diff === null;

  let trendColor = '#9CA3AF'; // Grey
  let TrendIcon = HorizontalRuleRoundedIcon;

  if (isUp) {
    trendColor = '#DC2626'; // Red
    TrendIcon = TrendingUpRoundedIcon;
  } else if (isDown) {
    trendColor = '#16A34A'; // Green
    TrendIcon = TrendingDownRoundedIcon;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        p: 2,
        borderRadius: '20px',
        bgcolor: details.bgColor,
        height: '100%',
        minHeight: '160px',
        width: '100%',
        position: 'relative',
        transition: 'transform 0.2s ease',
        '&:hover': { transform: 'scale(1.02)' }
      }}
    >
      <Box display="flex" alignItems="center" gap={1} mb={1}>
        <Box sx={{
          width: 28, height: 28, borderRadius: '8px', bgcolor: details.iconBoxColor,
          display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff',
          boxShadow: `0 2px 8px ${alpha(details.iconBoxColor, 0.4)}`
        }}>
          <IconComponent sx={{ fontSize: 18 }} />
        </Box>
        <Typography variant="subtitle2" fontWeight={800} sx={{ color: '#4B5563', fontSize: '0.85rem' }}>
          {details.name}
        </Typography>
      </Box>

      <Box mb={1.5}>
        <Typography variant="h5" fontWeight={600} sx={{ color: '#111827', fontSize: '1.25rem', letterSpacing: '-0.5px' }}>
          {premium}
        </Typography>
        
        {!isFlat && diff !== null && (
            <Box display="flex" alignItems="center" gap={0.5} mt={0.5}>
                <TrendIcon sx={{ fontSize: 16, color: trendColor }} />
                <Typography variant="caption" fontWeight={500} sx={{ color: trendColor, fontSize: '0.75rem' }}>
                    ${Math.abs(diff).toLocaleString()}
                </Typography>
            </Box>
        )}
         {isFlat && (
            <Box display="flex" alignItems="center" gap={0.5} mt={0.5}>
                 <Typography variant="caption" fontWeight={500} sx={{ color: '#9CA3AF', fontSize: '0.75rem' }}>
                    - No Change
                </Typography>
            </Box>
        )}
      </Box>

      <Box display="flex" justifyContent="space-between" alignItems="flex-end">
        <Box>
          <Typography variant="caption" sx={{ color: '#9CA3AF', fontWeight: 500, fontSize: '0.6rem', display: 'block', mb: 0.3 }}>
            QUOTA
          </Typography>
          <Typography variant="body2" fontWeight={500} sx={{ color: '#374151', lineHeight: 1 }}>
            {quota}
          </Typography>
        </Box>
        <Box textAlign="right">
          <Typography variant="caption" sx={{ color: '#9CA3AF', fontWeight: 500, fontSize: '0.6rem', display: 'block', mb: 0.3 }}>
            BIDS
          </Typography>
          <Typography variant="body2" fontWeight={500} sx={{ color: '#374151', lineHeight: 1 }}>
            {bids}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

const COEResultsCard = () => {
  const theme = useTheme();

  const [latestGroup, setLatestGroup] = useState<any[]>([]);
  const [previousGroup, setPreviousGroup] = useState<any[]>([]);
  const [nextBidLabel, setNextBidLabel] = useState<string>('Jan 7');
  const [loading, setLoading] = useState(true);

  // --- DATA FETCHING (Now uses hardcoded data instead of API) ---
  const fetchCOEData = () => {
    // Simulate a brief network delay so loading animation still works
    setTimeout(() => {
      try {
        const rawList = hardcodedCOEData;

        const grouped: Record<string, Record<string, any[]>> = {};
        rawList.forEach((item: any) => {
          if (!grouped[item.month]) grouped[item.month] = {};
          if (!grouped[item.month][item.biddingNo]) grouped[item.month][item.biddingNo] = [];
          grouped[item.month][item.biddingNo].push(item);
        });

        const sortedMonths = Object.keys(grouped).sort((a, b) =>
          new Date(b + '-01').getTime() - new Date(a + '-01').getTime()
        );

        let latest: any[] = [];
        let previous: any[] = [];
        let latestMonthStr = '';
        let latestBidNo = '';

        for (let i = 0; i < sortedMonths.length; i++) {
          const month = sortedMonths[i];
          const monthGroup = grouped[month];
          if (monthGroup['2']) {
            latest = monthGroup['2'];
            latestMonthStr = month;
            latestBidNo = '2';
            previous = monthGroup['1'] || []; 
            if(previous.length === 0 && grouped[sortedMonths[i+1]]) {
               previous = grouped[sortedMonths[i+1]]['2'] || grouped[sortedMonths[i+1]]['1'] || [];
            }
            break;
          } else if (monthGroup['1']) {
            latest = monthGroup['1'];
            latestMonthStr = month;
            latestBidNo = '1';
            previous = grouped[sortedMonths[i + 1]] ? (grouped[sortedMonths[i + 1]]['2'] || grouped[sortedMonths[i + 1]]['1']) : [];
            break;
          }
        }

        setLatestGroup(latest);
        setPreviousGroup(previous);

        if (latestMonthStr && latestBidNo) {
          const dateObj = new Date(latestMonthStr + '-01');
          if (latestBidNo === '1') {
            const m = dateObj.toLocaleString('default', { month: 'short' });
            setNextBidLabel(`${m} 19`);
          } else {
            dateObj.setMonth(dateObj.getMonth() + 1);
            const m = dateObj.toLocaleString('default', { month: 'short' });
            setNextBidLabel(`${m} 7`);
          }
        }

      } catch (err) {
        console.error('Error processing hardcoded COE data:', err);
      } finally {
        setLoading(false);
      }
    }, 500); // 500ms fake delay
  };

  useEffect(() => {
    fetchCOEData();
  }, []);

  const getCategoryData = (category: string) => {
    const current = latestGroup.find((i) => i.vehicleClass === `Category ${category}`);
    const prev = previousGroup.find((i) => i.vehicleClass === `Category ${category}`);
    
    const fallback = { premium: '-', quota: '-', bids: '-', diff: null };

    if (!current) return fallback;

    const premiumVal = parseNumberSafe(current.premium);
    const prevPremiumVal = prev ? parseNumberSafe(prev.premium) : premiumVal; 
    
    if (premiumVal === null) return fallback; 

    const diff = prevPremiumVal !== null ? premiumVal - prevPremiumVal : 0;

    return {
      premium: `$${premiumVal.toLocaleString()}`,
      quota: parseNumberSafe(current.quota)?.toLocaleString() || '-',
      bids: parseNumberSafe(current.bidsReceived)?.toLocaleString() || '-',
      diff: diff
    };
  };

  const latestData = latestGroup[0];
  const dateLabel = latestData
    ? `${new Date(latestData.month + '-01').toLocaleString('default', { month: 'short' })} ${latestData.biddingNo === '1' ? '1st' : '2nd'}`
    : loading ? 'Loading...' : 'Pending Data';

  return (
    <ButtonBase
      component="a"
      href="/coe-dashboard"
      sx={{
        width: '100%',
        height: '100%',
        borderRadius: '32px',
        textAlign: 'left',
        display: 'block',
        '&:focus-visible': { outline: '2px solid #FFA100' }
      }}
    >
      <MotionPaper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: '32px',
          backgroundColor: '#fff',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 4px 40px rgba(0,0,0,0.08)'
        }}
      >
        <Box mb={2.5}>
          <Box display="flex" justifyContent="space-between" alignItems="flex-start">
            <Typography variant={"h6"} fontWeight={800} sx={{ color: '#2c3e50', display: 'flex', alignItems: 'center', gap: 1 }}>
              COE Results
            </Typography>

            <Box display="flex" alignItems="center" gap={0.5} sx={{ opacity: 0.7 }}>
              <Typography variant="body2" sx={{ fontSize: '0.85rem', fontWeight: 500, color: '#4B5563' }}>
                View All
              </Typography>
              <Typography variant="body2" sx={{ fontSize: '1rem', fontWeight: 400, color: '#4B5563' }}>
                ›
              </Typography>
            </Box>
          </Box>

          <Box display="flex" alignItems="center" gap={1}>
            <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: loading ? '#D1D5DB' : '#84CC16' }} />
            <Typography variant="subtitle2" fontWeight={500} sx={{ color: '#6B7280' }}>
              {dateLabel}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ flexGrow: 1, mt: 1 }}>
          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="200px">
              <CircularProgress size={30} thickness={4} sx={{ color: '#E5E7EB' }} />
            </Box>
          ) : latestGroup.length === 0 ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="200px">
               <Typography variant="body2" color="textSecondary" sx={{ fontStyle: 'italic' }}>
                 No recent COE data available.
               </Typography>
            </Box>
          ) : (
            <Grid container spacing={2}>
              {COECategories.map((cat, index) => {
                const { premium, quota, bids, diff } = getCategoryData(cat);
                return (
                  <Grid size={{xs:6}} key={cat} sx={{
                    animation: `${fadeIn} 0.5s ease forwards`,
                    animationDelay: `${index * 0.1}s`,
                    opacity: 0
                  }}>
                    <CategoryGridItem
                      category={cat}
                      premium={premium}
                      quota={quota}
                      bids={bids}
                      diff={diff}
                    />
                  </Grid>
                );
              })}
            </Grid>
          )}
        </Box>
      </MotionPaper>
    </ButtonBase>
  );
};

export default COEResultsCard;